import baseApi from '../baseApi';
export default {
  baseUrl: '/api-piglet/api/accounting-package',
  create(form) {
    return baseApi.put(`${this.baseUrl}/v1`, form);
  },
  createCredits(form) {
    return baseApi.put(`${this.baseUrl}/v1/credits`, form);
  },
  fetchTodo(context) {
    return baseApi.get(`${this.baseUrl}/v1/todo/${context}`);
  },
  download(id) {
    return baseApi.get(`${this.baseUrl}/v1/download/${id}`);
  },
  requestDownload(packageId) {
    return baseApi.get(`${this.baseUrl}/v1/request-download/${packageId}`);
  },
}
